import React, { useEffect } from 'react';
import { Layout, AdBlock, AdImage } from '../../components';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import "./HowToUsers.scss";

const HowToUsers = () => {

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <Layout background="#1f2024">
            <div className="how-to-users">
                <div className="how-to-users__container">
                    <div className="how-to-users__content">
                        <h2 className="how-to-users__content--title">¿Cómo funciona Solucionarte?</h2>
                        <p>
                            Es muy simple. Ingresas a <span>www.solucionarte.ar</span>, generas una busqueda, comparas perfiles, reputación y precios, y contratas de manera directa con el profesional, sin ninguna intermediación.
                        </p>

                        <h3>Preguntas precuentes</h3>

                        <h4>¿Tiene algún costo?</h4>
                        <p>No. Es totalmente gratuito.
                            Sólo cobramos un pequeño valor a los profesionales que se comuniquen contigo, por lo que te pedimos que inicies proyectos solo si tienes la intención de contratar.
                            Si tan sólo deseas conocer un aproximado de costos, puedes encontrar el valor de muchos servicios en la sección precios de referencia.</p>

                        <h4>¿Cual es la ventaja de usar Solucionarte?</h4>
                        <p>A diferencia de otras opciones para hallar profesionales, en HomeSolution.net:

                            Eliges una categoría, sigues los pasos y en pocas horas, recibirás hasta 5 respuestas entre las cuales comparar y contratar. Esta es la forma más elegida por los usuarios.
                            Desde el buscador, escribes el nombre de la especialidad o profesional que te interesa, y te pones en contacto directo.
                            Navegas el directorio, comparas perfiles y eliges a los que te resulten más adecuados.</p>

                        <h4>¿Qué información debería proveer?</h4>
                        <p>La mayor cantidad posible. El proyecto que tienes en mente, medidas, estado del lugar donde se hará el trabajo, ubicación, si proveerás los materiales, etcétera. También puedes adjuntar fotos una vez que hayas recibido las propuestas.</p>

                        <h4>¿Cual es la ventaja de usar Solucionarte?</h4>
                        <p>A diferencia de otras opciones para hallar profesionales, en HomeSolution.net:

                            Eliges una categoría, sigues los pasos y en pocas horas, recibirás hasta 5 respuestas entre las cuales comparar y contratar. Esta es la forma más elegida por los usuarios.
                            Desde el buscador, escribes el nombre de la especialidad o profesional que te interesa, y te pones en contacto directo.
                            Navegas el directorio, comparas perfiles y eliges a los que te resulten más adecuados.</p>

                        <h4>¿Cuántos presupuestos recibiré?</h4>
                        <p>Recibirás en tu casilla de correo hasta un máximo de 5 y apuntamos a que no sean menos de 2. Mientras más detallada sea tu consulta, más respuestas recibirás. Mismo si incluyes tu número de teléfono.</p>

                        <h4>¿Puedo confiar en los profesionales de la plataforma?</h4>
                        <p>Todos los profesionales son chequeados previo a su ingreso a la plataforma. Asimismo se mantienen entrevistas telefónicas con ellos, y con los clientes que haya puesto de referencia.

                            Una vez aceptados para formar parte, pueden mejorar su reputación a través de diferentes sellos profesionales y de las calificaciones que van obteniendo, trabajo a trabajo.

                            Creemos que sólo los Mejores Profesionales pueden proveer las Mejores Soluciones, y por ello hacemos mucho hincapié en su confiabilidad.</p>

                        <h4>¿A quién debo abonarle?</h4>
                        <p>Directamente al profesional. No cobramos ninguna comisión ni costo extra.</p>

                        <h4>Termine el trabajo, ¿ahora qué hago?</h4>
                        <p>Cuando hayas tomado la decisión de contratar un prestador, o si has encontrado otra alternativa, puedes cerrar el proyecto desde cualquiera de los chats y así, evitar seguir recibiendo propuestas o mensajes. Además le agradeces automáticamente a los profesionales que se tomaron la molestia de escribir.
                            Si has indicado que contrataste a alguno de los profesionales, podrás calificarlo.</p>

                        <h4>¿Cómo califico a un prestador?</h4>
                        <p>Puedes hacerlo desde el chat que tienes con él o entrando a su perfil. En ambos casos tocas el botón de calificar y sigues los pasos.</p>

                        <h4>¿Puedo cambiar una calificación emitida?</h4>
                        <p>Si, sólo debes calificar al mismo profesional nuevamente, y tu nueva calificación reemplazará a la anterior.</p>

                        <h4>¿Qué sucede si no estoy conforme con un trabajo?</h4>
                        <p>Te pones en contacto con el prestador, para que la solución a tu necesidad sea más ágil y transparente. Home Solution no intermedia en la relación aunque sí colabora en el entendimiento de las partes. Si no logras una respuesta satisfactoria de su parte, puedes escribir a reclamos@homesolution.net y nuestro staff ayudará para que encuentren un punto de acuerdo.</p>

                        <h4>Si necesito nuevamente a un profesional con el que ya hablé, ¿dónde lo encuentro?</h4>
                        <p>Cuando haces una consulta, se te genera una cuenta dentro de la cual tendrás la sección de Mensajes. Allí encontrarás todas las conversaciones que hayas mantenido.</p>

                        <h4>¿Dónde puedo ver precios de referencia?</h4>
                        <p>Puedes encontrar el precio de los principales servicios aquí www.solucionarte.ar Cada 3 meses hacemos un relevamiento entre nuestros profesionales para hallar un verdadero precio de mercado, sin perder de vista que cada trabajo tiene requisitos particulares.

                            Los precios no son vinculantes sino más bien orientativos, pero te servirán para ver si están dentro de tu presupuesto antes de generar una consulta.</p>
                    </div>

                    <div className="how-to-users__ads">
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default HowToUsers;
